import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/shared/services/translation/translation.service';
import { Router } from '@angular/router';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
})
export class PresentationComponent implements OnInit {
  animationItem: AnimationOptions;

  public get availableTranslationLocales(): { key: string; locale: string }[] {
    return this.translationService.availableTranslationLocales;
  }

  public get currentTranslationLocale(): string {
    return this.translationService.currentTranslationLocale;
  } 

  constructor(private router : Router,private readonly translationService: TranslationService) {}

  public ngOnInit(): void {
    if(this.router.url=='/login'){
      this.animationItem = {
        loop:true,
        path: './assets/images/login.json',
      };
    }
    else{
      this.animationItem = {
        loop:true,
        path: './assets/images/landing-page/landing-page.json',
      };
    }
  }

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(0.3)
  }


  public onClickTranslationLocale(locale: { key: string; locale: string }): void {
    this.translationService.setLocale(locale.locale);
  }
}
